export default {"src":"/_next/static/media/payment-master-icon.82b60bcf.svg","height":20,"width":29};